import React from 'react';
import '../assests/css/font-size-family.css';
import Header from '../Components/Headers/Header';
import '../assests/css/PrivacyPolicy.css';
import Footer from '../Components/Footers/Footer';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
    return (
        <div className='privacypolicy policiez'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container px-5'>
                    <div className='row'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Cookie Policy</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='policies pt-5 pb-5'>
                <div className='container  p-cus-policy'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <p className='f-25 f-pop-med'>Cookies </p>
                            <p className='f-14 mt-4 mb-4 f-pop-reg'>
                                A cookie is a small amount of data that a web server sends to a browser and the browser saves. Each time a page from the server is requested, the data is sent back to the browser. In this way, the webserver is able to identify and monitor the browser.
                            </p>
                            <p className='f-14 mt-4 mb-4 f-pop-reg'>
                                We may employ both "session" and "permanent" cookies on our website. Session cookies are used to: track your movements across the website while you're logged in. Persistent cookies allow us to recognise you each time you visit our website. When you close your browser, session cookies will be removed from your machine. Cookies that are persistent are those that remain on your computer after you erase them or until they expire. In order to better understand how people interact with this website, we employ Google Analytics. Using cookies, Google Analytics generates statistical and other information about how people use a website. The data gathered from our website's visitors are utilised to compile usage statistics. For future reference, Google will save this data.
                                In order to learn more about Google's privacy policies, please visit: <span className='link_style' onClick={() => { window.open('http://www.google.com/privacypolicy.html', '_blank'); }} >  http://www.google.com/privacypolicy.html  </span>

                            </p>
                            <p className='f-14 mt-4 mb-4 f-pop-reg'>
                                Cookies may also be sent to you by our advertising or payment service providers. It is possible to refuse all cookies in most browsers. However, this is not always possible in all browsers. However, in Internet Explorer, by clicking Tools, Internet Options, and Privacy, as well as the sliding picker, you can block all cookies. Even if you block all cookies, many websites will no longer function properly.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default CookiePolicy;